import React from 'react';
import { Box, Col, Heading, Row } from '@digitools/honest-react';
import useDentalDataContext from 'src/packages/dental/hooks/useDentalContext';
import useMediaQuery from 'src/hooks/useMediaQuery';
export const PlanOverview = () => {
    const { subscriber } = useDentalDataContext();
    const isTitleView = useMediaQuery('(max-width: 780px)');
    const data = subscriber?.planOverview;
    let groupName = '';
    const blankKeyPair = { value: '', label: '', dataPublic: false };
    let multiColumnData = [
        { col1: blankKeyPair, col2: blankKeyPair },
        { col1: blankKeyPair, col2: blankKeyPair },
        { col1: blankKeyPair, col2: blankKeyPair },
    ];
    let planOverviewEntriesMobile = [];
    let hasData = false;
    let lastRowIndex = 2;
    if (data) {
        groupName = `${data.groupName?.label} ${data.groupName?.value}` || '';
        let col1Index = 0;
        let col2Index = 0;
        ['groupPolicyNum', 'coverageType', 'benefitPeriod'].forEach(key => {
            if (data[key] && data[key].value != null && data[key].label) {
                planOverviewEntriesMobile.push(data[key]);
                planOverviewEntriesMobile[planOverviewEntriesMobile.length - 1].dataPublic = key != 'groupPolicyNum';
                multiColumnData[col1Index]['col1'] = data[key];
                multiColumnData[col1Index]['col1'].dataPublic = key != 'groupPolicyNum';
                col1Index += 1;
            }
        });
        ['terminationDate', 'dependentAgeLimit', 'studentAgeLimit'].forEach(key => {
            if (data[key] && data[key].value != null && data[key].label) {
                planOverviewEntriesMobile.push(data[key]);
                planOverviewEntriesMobile[planOverviewEntriesMobile.length - 1].dataPublic = true;
                multiColumnData[col2Index]['col2'] = data[key];
                multiColumnData[col2Index]['col2'].dataPublic = true;
                col2Index += 1;
            }
        });
        lastRowIndex = Math.max(col1Index, col2Index) - 1;
        hasData = !!col1Index || !!col2Index;
    }
    const PlanOverviewColumn = ({ isLastRow, entry, labelWidth }) => {
        let labelCss = isLastRow ? 'pb-1' : 'mb-4 pb-1';
        const valueCss = isLastRow ? 'pb-0 pl-0' : 'mb-4 pb-0 pl-0';
        let paragraphCss = 'pb-1 mr-3 h-100';
        const hasEntryData = entry.label;
        if (hasEntryData) {
            labelCss += ' border-bottom';
            paragraphCss += ' border-bottom';
        }
        return (<>
        <Col md={labelWidth} className={labelCss} style={{ fontWeight: '500' }} data-public={true}>{entry.label}</Col>
        <Col md={6 - labelWidth} className={valueCss}>
          <div className={paragraphCss} data-private>
            <p className={'text-right font-weight-light pb-1'}>{entry.value}</p>
          </div>
        </Col>
      </>);
    };
    const PlanOverviewHeader = () => (<Row>
      <Col>
        <Heading aria-labelledby={'planOverview'} elemType={isTitleView ? 'h3' : 'h2'} style={{
            fontSize: '1.113rem',
            fontWeight: 'normal',
            fontFamily: 'Roboto, sans-serif',
        }} color={'secondaryDark'} data-private>
          {groupName}
        </Heading>
      </Col>
    </Row>);
    return (<section aria-labelledby={'planOverview'} aria-label={'planOverview'} className={'mt-0'}>
      {hasData && isTitleView && (<Box data-testid={'mobileDataContainer'}>
          <PlanOverviewHeader />
          {planOverviewEntriesMobile.map((entry, index) => (<Row className={'border-bottom pb-2'}>
              <Col id={'planOverviewDataLabel'} data-public={true}>{entry.label}</Col>
              <Col>
                <p className={'text-right font-weight-light w-100'} id={'planOverviewDataValue' + index} data-testid={'planOverviewDataValue' + index} data-private>
                  {entry.value}
                </p>
              </Col>
            </Row>))}
        </Box>)}
      {hasData && !isTitleView && (<Box data-testid={'desktopDataContainer'}>
            <PlanOverviewHeader />
            <Row className={'flex-row'}>
              {multiColumnData &&
                multiColumnData.map((entry, index) => (<>
                    <PlanOverviewColumn entry={entry.col1} isLastRow={index === lastRowIndex} labelWidth={2}/>
                    <PlanOverviewColumn entry={entry.col2} isLastRow={index === lastRowIndex} labelWidth={4}/>
                  </>))}
            </Row>
          </Box>)}
    </section>);
};
export default PlanOverview;
